/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Searchplaceholder2Inputs */

const en_coinvestments_insights_searchplaceholder2 = /** @type {(inputs: Coinvestments_Insights_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search by organisation name`)
};

/**
* | output |
* | --- |
* | "Search by organisation name" |
*
* @param {Coinvestments_Insights_Searchplaceholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_searchplaceholder2 = /** @type {((inputs?: Coinvestments_Insights_Searchplaceholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Searchplaceholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_searchplaceholder2(inputs)
});
export { coinvestments_insights_searchplaceholder2 as "coInvestments_insights_searchPlaceholder" }